import { fetcher } from '../utils'

export default async (messageId: string): Promise<void> =>
  fetcher(`/api/chats/${messageId}/update/status/read`, 'POST', {})
